import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useSelector } from 'react-redux';
import './VideoPlay.css';
import VideoPlay from './VideoPlay';

const Section2 = () => {
  const eventData = useSelector((state) => state.event.eventData);
  const video = eventData.invitation;
  const videourl = eventData.invitation.Records || [];
  const background = eventData.invitation.imageKey;

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selecteddata, setSelectedData] = useState("");
console.log("videourl",videourl)
  // Extract video ID from full YouTube URL
  const getVideoId = (url) => {
    const match = url?.match(/(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  };

  const getThumbnail = (url) => {
    const id = getVideoId(url);
    return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : '';
  };

  const handleOpenPopup = (url, data) => {
    console.log("url",url)
    setSelectedVideo(url);
    setSelectedData(data);
  };

  const handleClosePopup = () => {
    setSelectedVideo(null);
  };

  return (
    <div>
      <section
        className="category-area3 bg-smoke space"
        style={{ backgroundImage: `url(${background})` }}
      >
        <div className="container th-container">
          <div className="title-area text-center">
            <span className="sub-title">{video.title}</span>
            <h2 className="sec-title">{video.subTitle}</h2>
          </div>

          <div className="slider-area">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={5}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 3 },
                1400: { slidesPerView: 5 },
              }}
              className="category-slider3"
            >
              {videourl.flat().filter(Boolean).map((cat, index) => (
                <SwiperSlide key={index}>
                  <div className="category-card single2">
                    <div className="box-img global-img">
                      <img src={getThumbnail(cat.title)} alt={cat.description} />
                    </div>
                   
                    <a onClick={() => handleOpenPopup(cat.title, cat.description)} >View</a>

                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      {/* Popup Modal */}
      {selectedVideo && (
    <VideoPlay
    videoUrl={selectedVideo}
    data={selecteddata}
    onClose={() => setSelectedVideo(null)}
  />
)}

    </div>
  );
};

export default Section2;
